export const selectObject = (object) => {
  window.canvas.deselectAll()
  object.selectable = true
  const id = window.canvas.getObjects().indexOf(object)
  window.canvas.setActiveObject(window.canvas.item(id))
  window.canvas.requestRenderAll()
}
